export default __webpack_public_path__ + "static/media/mikan.74befc9d.jpg";